var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeacherFeedbackSmallBadge = function SvgTeacherFeedbackSmallBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 5.75,
    fill: "#DBFADF",
    stroke: "#979797",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#378142",
    d: "m10.5 5 .058.003A.5.5 0 0 1 11 5.5v5l-.003.058A.5.5 0 0 1 10.5 11h-5l-.058-.003A.5.5 0 0 1 5 10.5v-5l.003-.058A.5.5 0 0 1 5.5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4EA15A",
    d: "M10 6H6v4h4z"
  }))));
};
export default SvgTeacherFeedbackSmallBadge;